import {
  createMaterialTopTabNavigator,
  MaterialTopTabNavigationEventMap,
  MaterialTopTabNavigationOptions
} from "expo-router/js-top-tabs";
import { TabNavigationState } from "expo-router/react-navigation";
import { Image } from 'expo-image';
import { router, useUnstableGlobalHref, withLayoutContext } from 'expo-router';
import { Platform, Pressable, StyleSheet, useWindowDimensions, View } from 'react-native';

import { filterIcon } from '@/assets/images/icons';
import { underlineTopTabOptions } from '@/constants/layout';
import { ParamListBase } from '@/types/navigation';
import { i18n } from '@/utils/i18n';

const { Navigator } = createMaterialTopTabNavigator();
export const MaterialTopTabs = withLayoutContext<
  MaterialTopTabNavigationOptions,
  typeof Navigator,
  TabNavigationState<ParamListBase>,
  MaterialTopTabNavigationEventMap
>(Navigator);

const NpoLayout = () => {
  const { width } = useWindowDimensions();
  const unstable_globalHref = useUnstableGlobalHref();

  //Locales
  const charities_tab = i18n.t('home.charities');
  const churches_tab = i18n.t('home.churches');

  return (
    <View style={style.mainContainer}>
      <MaterialTopTabs screenOptions={underlineTopTabOptions({ width: width })}>
        <MaterialTopTabs.Screen name="index" options={{ title: charities_tab, tabBarPressColor: 'transparent' }} />
        <MaterialTopTabs.Screen name="churches" options={{ title: churches_tab, tabBarPressColor: 'transparent' }} />
      </MaterialTopTabs>
      <Pressable
        onPress={() =>
          router.navigate({
            pathname: '/filters',
            params: {
              from: unstable_globalHref
            }
          })
        }
        style={[style.filterButton, { right: Platform.OS === 'web' ? 0 : 18 }]}>
        <Image source={filterIcon} style={style.filterIcon} contentFit="contain" />
      </Pressable>
    </View>
  );
};

export default NpoLayout;

const style = StyleSheet.create({
  mainContainer: {
    flex: 1
  },

  filterButton: {
    position: 'absolute',
    top: 15
  },

  filterIcon: {
    height: 20,
    width: 20
  }
});
